/* eslint-disable jsx-a11y/no-autofocus */
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useSearchParam } from 'react-use';
import { Box } from 'reflexbox';

import { Button, Input, Label, Paragraph, Portal, UnderlineLink } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import BareLayout from 'packages/kakapo-ui-application/layouts/BareLayout';
import GraphQLErrorMessage from 'packages/kakapo-ui-kit/components/forms/errors/GraphQLErrorMessage';
import PublicForm from 'packages/kakapo-ui-kit/components/forms/layouts/PublicForm';
import useErrorBoundary from 'packages/kakapo-ui-application/hooks/useErrrorBoundary';

export default function Prelogin() {
	const { t } = useTranslation();

	const [error, attempt] = useErrorBoundary();

	const [prelogin] = graphql.usePreloginMutation();
	const redirect = useSearchParam('redirect');

	async function onSubmit(variables: { login: string }) {
		const response = await prelogin({
			variables: {
				input: {
					login: variables.login,
				},
			},
		});

		window.location.href =
			response.data!.prelogin.url + (redirect ? '&redirect=' + encodeURIComponent(redirect) : '');
	}

	return (
		<Portal.Provider>
			<BareLayout>
				<Formik initialValues={{ login: '' }} onSubmit={attempt(onSubmit)}>
					{({ isSubmitting, values, submitForm }) => (
						<PublicForm>
							<GraphQLErrorMessage error={error} />

							<Box mb={3}>
								<Label mb={2}>{t('common.email')}</Label>
								<Input.Formik name="login" autoFocus />
							</Box>

							<Button
								mb={3}
								title={t('common.next')}
								disabled={values.login === '' || isSubmitting}
								onClick={submitForm}
							/>

							<Paragraph textAlign="center">
								{t('prelogin.noAccount.description')}{' '}
								<UnderlineLink href="https://try.ontreams.com">
									{t('prelogin.noAccount.buttonTitle')}
								</UnderlineLink>
							</Paragraph>
						</PublicForm>
					)}
				</Formik>
			</BareLayout>
		</Portal.Provider>
	);
}
